import React, { useState, useEffect } from "react";
import { Container, Button, Card, CardBody } from "reactstrap";

import TuneIcon from "@mui/icons-material/Tune";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import History from "./History";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReplayIcon from "@mui/icons-material/Replay";
import {
  user_requisition,
  user_filter,
  filter_requistion,
} from "../../api/requisition";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { StorePageHeaderName } from '../../store/pageHeader/action';
import { useDispatch } from "react-redux";

const CustomDataGrid = styled(DataGrid)({
  "& .MuiDataGrid-cell": {
    "& .MuiTooltip-tooltip": {
      display: "none",
    },
  },
});
const RequisitionHistory = () => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
  const [productList, setProductList] = useState([]); // State variable for product list
  const [reqNoList, setReqNoList] = useState([]); // State variable for product list
  const [selectedProductName, setSelectedProductName] = useState(null);
  const [selectedReqNo, setSelectedReqNo] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const allStatuses = [
    {
      label: "Approval pending",
      value: "APPROVAL_PENDING",
    },
    {
      label: "Exess Quantity",
      value: "EXCESS_APPROVED",
    },
    {
      label: "Partial apprved",
      value: "PARTIALLY_APPROVED",
    },
    {
      label: "Complete Approved",
      value: "COMPLETE_APPROVED",
    },

  ];

  document.title = "Dashboard | Procurement Dashboard";

  const handleProductNameClick = (isOpen, id) => {
    setOpen(isOpen);
    setSelectedRowId(id); // Set the selected row id
  };
  const [showList, setShowList] = useState(false);


  const toggleList = () => {
    setShowList(!showList);
  };
  useEffect(()=>{
    dispatch(StorePageHeaderName('My Requisition'))

},[])


  const columns = [
    {
      field: "Sl_No",
      headerName: "Sl.No",
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "right-aligndata",
      flex: 0.8,
    },
    // {
    //   field: "Requisition_No",
    //   headerName: "Requisition No",
    //   editable: false,
    //   headerClassName: "break-header",
    //   cellClassName: "product_name_wrap",
    //   resizable: false,
    //   sortable: false,
    //   flex: 1,
    // },
    {
      field: "Requisition_Date",
      headerName: "Requisition Date",
      editable: false,
      headerClassName: "break-header",
      resizable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        const RequisitionDate = params.value;
      },
    },
    {
      field: "Product_Name",
      headerName: "Product Name",
      editable: false,
      headerClassName: "break-header",
      cellClassName: "product_name_wrap",
      resizable: false,
      sortable: false,
      width: 160,
      renderCell: (params) => {
        const productName = params.value;
        // return (
        //   <div onClick={() => handleProductNameClick(true,params.id)}>
        //     {productName}
        //   </div>
        // );
      },
      // flex: 1.5,
    },
    {
      field: "Total_Qty",
      headerName: "Total Quantity",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      headerClassName: "break-header",
      flex: 1,
    },
    {
      field: "approved",
      headerName: "Approved",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "remaining",
      headerName: "Remaining",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "Allocation_QTY",
      headerName: "Allocation (QTY)",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      headerClassName: "break-header",
      flex: 1.5,
    },

    {
      field: "Arival_Date",
      headerName: "Arival Date",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "Value",
      headerName: "Value",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "Status",
      headerName: "Status",
      // description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      width: 180,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1.5,
      renderCell: (params) => {
        let status = params.value;
        let chipColor = "default";
        let name = "";
        if (status === "APPROVAL_PENDING" || status === "SAVED") {
          chipColor = "error";
          status = "Approval Pending";
          name = "status_badge mt-1";
        } 
        else if (
          status === "COMPLETE_APPROVED" ||
          status === "PARTIALLY_APPROVED"
        ) {
          if (status === "COMPLETE_APPROVED") {
            status = "Completely Approved";
          } else if (status === "PARTIALLY_APPROVED") {
            status = "Partially Approved";
          }
          name = "success_badge mt-1"
          chipColor = "success"
          // name = "success_badge mt-1";

          // chipColor = "success mt-1";
        }
        return (
          <Chip
            className={name}
            label={status}
            variant="outlined"
            color={chipColor}
          />
        );
      },
    },
  ];

  const fetchRequisitionHistory = async () => {
    try {
      setIsLoading(true);
      let count = 0; // Initialize the count variable outside the map function
      const response = await user_requisition();

      if (response.statusCode === 200) {
        if (response.data.getRequisition.length > 0) {
          const requisitionItems = response.data.getRequisition.flatMap(
            (requisition) =>
              requisition.procurementRequisitionItem.map((item) => ({
                id: item.id,
                Sl_No: ++count,
                Requisition_No: requisition.requisition_number,
                Requisition_Date: requisition.requisition_date,
                Product_Name: item.item_name,
                Total_Qty: item.total_qty,
                approved: item.approved_qty,
                remaining: item.total_qty - item.approved_qty,
                Value: item.value,
                Allocation_QTY: item.allocation_qty,
                // Actual_Date: '--',
                // Modified_Date:'--',
                Arival_Date: item.arrival_date,
                Status: item.status,
              }))
          );
          setRows(requisitionItems); // Update rows state with fetched data
        }
      }
    } catch (error) {
      console.error("Error fetching requisition history:", error);
      toast.error("Something went wrong");
      // Handle error
    } finally {
      setIsLoading(false); // Reset loading state after operation completes
    }
  };

  // useEffect(() => {
  //  console.log('useeffect')
  //   fetchRequisitionHistory();

  // }, []);
  useEffect(() => {
    if (showList) {
      const fetchProductList = async (search_type) => {
        try {
          const response = await user_filter({ search_type });
          if (response.statusCode === 200) {
            if (search_type === "productName") {
              if (response.data.product.length > 0) {
                setProductList(response.data.product); // Update productList state with fetched data
              }
            } else if (search_type === "reqNo") {
              if (response.data.reqNo.length > 0) {
                setReqNoList(response.data.reqNo); // Update productList state with fetched data
              }
            }
          }
        } catch (error) {
          console.error("Error fetching product list:", error);
          toast.error("Something went wrong");
        }
      };
      fetchProductList("productName");
      fetchProductList("reqNo");
    } else {
      handleReset();
    }
  }, [showList]);
  const handleProductNameChange = (event, value) => {
    setSelectedProductName(value);
  };

  const handleReqNoChange = (event, value) => {
    setSelectedReqNo(value);
  };

  const handleSearch = async () => {
    try {
      setIsLoading(true); // Set loading state
      if (
        (selectedDate && !selectedEndDate) ||
        (!selectedDate && selectedEndDate)
      ) {
        toast.error("Please select valid daterange.");
        return;
      }

      let count = 0;
      let searchCriteria = {};

      if (selectedProductName) {
        searchCriteria.product = selectedProductName.value;
      }

      if (selectedReqNo) {
        searchCriteria.reqNo = selectedReqNo.value;
      }
      if (selectedDate && selectedEndDate) {
        searchCriteria.startDate = dayjs(selectedDate).format("YYYY-MM-DD");
        searchCriteria.endDate = dayjs(selectedEndDate).format("YYYY-MM-DD");
      }

      if (selectedStatus) {
        searchCriteria.status = selectedStatus.value;
      }

      const response = await filter_requistion(searchCriteria);

      if (response.statusCode === 200) {
        if (response.data.getRequisition.length > 0) {
          const requisitionItems = response.data.getRequisition.flatMap(
            (requisition) =>
              requisition.procurementRequisitionItem.map((item) => ({
                id: item.id,
                Sl_No: ++count,
                Requisition_No: requisition.requisition_number,
                Requisition_Date: requisition.requisition_date,
                Product_Name: item.item_name,
                Total_Qty: item.total_qty,
                approved: item.approved_qty,
                remaining: item.total_qty - item.approved_qty,
                Value: item.value,
                Allocation_QTY: item.allocation_qty,
                // Actual_Date: '--',
                // Modified_Date: '--',
                Arival_Date: item.arrival_date,
                Status: item.status,
              }))
          );
          setRows(requisitionItems); // Update rows state with fetched data
        } else {
          setRows([]);
        }
      }
    } catch (error) {
      console.error("Error searching requisition:", error);
      toast.error("Something went wrong while searching");
    } finally {
      setIsLoading(false); // Reset loading state after operation completes
    }
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
  };
  const handleReset = () => {
    setSelectedProductName(null);
    setSelectedReqNo(null);
    setSelectedDate(null);
    setSelectedEndDate(null);
    setSelectedStatus(null);
    fetchRequisitionHistory();
  };
  const handleRowClick = (params) => {
    handleProductNameClick(true, params.id);
  };
  return (
    <React.Fragment>
      {open && (
        <History
          handleProductNameClick={handleProductNameClick}
          selectedRowId={selectedRowId} // Pass selectedRowId
        />
      )}
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="My Requisition" pageTitle="Requisitions"/> */}
          <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <h3 className="requisition_text mb-0">Requisition History</h3>
              </div>
              <div>
                <button onClick={toggleList} className="filter_button">
                  <span className="me-2">
                    <TuneIcon />
                  </span>
                  Filter
                </button>
              </div>
            </div>
            {showList && (
              <div
                className="mt-1 mb-2"
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="product-name"
                    options={productList}
                    sx={{ width: 280 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Product Name" />
                    )}
                    onChange={handleProductNameChange}
                    value={selectedProductName}
                  />
                </div>
                <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="requisition-number"
                    options={reqNoList}
                    sx={{ width: 240 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Requisition Number" />
                    )}
                    onChange={handleReqNoChange}
                    value={selectedReqNo}
                  />
                </div>
                <div className="d-flex">
                  <div>
                    {/* <button className="date_button" variant="contained" onClick={datepickeropenModal}>Select Date</button> */}
                    <LocalizationProvider
                      className="date_picker"
                      dateAdapter={AdapterDayjs}
                    >
                      <DatePicker
                        className="date_picker"
                        label="From Date"
                        value={selectedDate}
                        maxDate={selectedEndDate}
                        onChange={handleDateChange}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="ms-2">
                    <LocalizationProvider
                      className="date_picker"
                      dateAdapter={AdapterDayjs}
                    >
                      <DatePicker
                        className="date_picker"
                        label="To Date"
                        value={selectedEndDate}
                        minDate={selectedDate}
                        onChange={handleEndDateChange}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div>
                    <Autocomplete
                      className="data_field"
                      disablePortal
                      id="combo-box-demo"
                      options={allStatuses}
                      onChange={(_, value) => setSelectedStatus(value)}
                      value={selectedStatus}
                      sx={{ width: 150 }}
                      renderInput={(params) => (
                        <TextField {...params} label="Status" />
                      )}
                    />
                  </div>
                <div className="d-flex align-items-center">
                  <button
                    className="me-2 search_button"
                    variant="outlined"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <ReplayIcon onClick={handleReset} />
                </div>
              </div>
            )}
            {/* <Box sx={{ height: 400, width: '100%', marginBottom:'10px' }}>
                    <DataGrid
                      className="table_header_background"
                      headerClassName="custom-header-cell"
                        rows={rows}
                        columns={columns}
                        loading={isLoading} // Set loading state
                        initialState={{
                            // pagination: {
                            //     paginationModel: {
                            //         pageSize: 5,
                            //     },
                            // },

                        }}
                        pageSizeOptions={[]}
                        disableRowSelectionOnClick
                        onRowClick={handleRowClick}
                    />
                    
                </Box> */}
            <Box
              sx={{
                maxWidth: "100%",
                overflowX: "auto",
                marginBottom: "10px",
                height: '100%',
              }}
            >
              <DataGrid
                autoHeight
                disableColumnSorting
                className="table_header_background"
                headerClassName="custom-header-cell"
                getRowHeight={() => "auto"}
                rows={rows}
                columns={columns}
                loading={isLoading} // Set loading state
                disableColumnMenu
                componentsProps={{
                  cell: {
                    disableClick: true,
                  },
                }}
                sx={{
                  "& .MuiDataGrid-cell": {
                    "& .MuiDataGrid-cell--textOverflow": {
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  },
                }}
                initialState={{
                  pagination: {
                    pageSize: 50, // Set the number of rows per page
                  },
                }}
                // Remove pageSizeOptions to show pagination controls
                onRowClick={handleRowClick} // Handle row click event
              />
            </Box>
          </div>
          {/* <Card>
                        <CardBody className="pe-0 ps-0 pt-0">
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total Approved</th>
                                            <th className="text-center">Total Remaining</th>
                                            <th className="text-center">Total Value</th>


                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{rows.length}</td>
                                                
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Total_Qty;
                                                }, 0)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.approved;
                                                }, 0)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.remaining;
                                                }, 0)}</td>
                                                <td className="text-center">{rows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Value;
                                                }, 0)}</td>
                                            </tr>
                                        
                                    </tbody>
                            
                                </table>
                            </div>
                        </CardBody>
                    </Card> */}
        </Container>
      </div>
      {/* <Modal
                isOpen={datePickermodalIsOpen}
                onRequestClose={datepickercloseModal}
                contentLabel="Example Modal"
                className="datepicker_modal modal_box"
            > */}
      {/* <h4 className='ms-3'>Do You Want To Submit This Requsition</h4> */}
      {/* <div className='d-flex justify-content-end me-3 mt-2 modal_close'>
                    <i class="ri-close-line" onClick={datepickercloseModal}></i>
                </div>
                <ModalBody className='pt-2'>
                    <div>
                        <DateRangePicker
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={1}
                            editableDateInputs={true}
                            ranges={dateRangeData}
                            direction="horizontal"
                            className="w-100 datepicker_customise"
                            rangeColors={['#0060AA']}
                        />
                    </div>
                </ModalBody> */}
      {/* </Modal> */}
    </React.Fragment>
  );
};

export default RequisitionHistory;
